import { render, staticRenderFns } from "./ViewCandidates.vue?vue&type=template&id=611414c0&scoped=true"
import script from "./ViewCandidates.vue?vue&type=script&lang=ts"
export * from "./ViewCandidates.vue?vue&type=script&lang=ts"
import style0 from "./ViewCandidates.vue?vue&type=style&index=0&id=611414c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611414c0",
  null
  
)

export default component.exports